import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [showNotification, setShowNotification] = useState(false);

  const languages = [
    { code: 'nl', name: 'Nederlands', flag: '🇧🇪', available: true },
    { code: 'en', name: 'English', flag: '🇬🇧', available: false },
    { code: 'fr', name: 'Français', flag: '🇫🇷', available: false }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const changeLanguage = (langCode, isAvailable) => {
    if (!isAvailable) {
      // Show "in opbouw" notification
      setShowNotification(true);
      setIsOpen(false);
      setTimeout(() => {
        setShowNotification(false);
      }, 3000);
      return;
    }
    
    i18n.changeLanguage(langCode);
    setIsOpen(false);
    // Update HTML lang attribute for SEO
    document.documentElement.lang = langCode;
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 hover:opacity-80 transition-opacity duration-200 py-2"
        title={currentLanguage.name}
      >
        <span className="text-2xl">{currentLanguage.flag}</span>
      </button>

      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute right-0 mt-2 w-56 bg-white  shadow-xl border border-terra-beige/20 py-2 z-50">
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => changeLanguage(lang.code, lang.available)}
                className={`w-full px-4 py-2 text-left font-sweet-sans text-sm hover:bg-terra-beige/10 transition-colors flex items-center justify-between gap-3 ${
                  i18n.language === lang.code ? 'bg-terra-beige/5 text-terra-beige' : 'text-almost-black'
                } ${!lang.available ? 'opacity-70' : ''}`}
              >
                <div className="flex items-center gap-3">
                  <span className="text-xl">{lang.flag}</span>
                  <span>{lang.name}</span>
                </div>
                {!lang.available && (
                  <span className="text-xs bg-earth-brown/10 text-earth-brown px-2 py-1 ">
                    In opbouw
                  </span>
                )}
              </button>
            ))}
          </div>
        </>
      )}

      {/* Notification Toast */}
      {showNotification && (
        <div className="fixed top-24 right-4 bg-earth-brown text-white px-6 py-4  shadow-2xl z-50 animate-fadeIn">
          <div className="flex items-center gap-3">
            <span className="text-2xl">🚧</span>
            <div>
              <p className="font-sweet-sans text-sm font-semibold">Vertaling in opbouw</p>
              <p className="font-sweet-sans text-xs opacity-90">Deze taal is momenteel nog niet beschikbaar</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
